/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MasivosService {
    private mostrarReporteEncuestas = new BehaviorSubject<boolean>(false);
    private mostrarReportePlantillas = new BehaviorSubject<boolean>(false);
    private mostrarMostrarMasivos = new BehaviorSubject<boolean>(true);

    mostrarReporteEncuestas$ = this.mostrarReporteEncuestas.asObservable();
    mostrarReportePlantillas$ = this.mostrarReportePlantillas.asObservable();
    mostrarMostrarMasivos$ = this.mostrarMostrarMasivos.asObservable();

    setMostrarReporteEncuestas(value: boolean) {
        this.mostrarReporteEncuestas.next(value);
    }

    setMostrarReportePlantillas(value: boolean) {
        this.mostrarReportePlantillas.next(value);
    }

    setMostrarMasivos(value: boolean) {
        this.mostrarMostrarMasivos.next(value);
    }
}
